import { render, staticRenderFns } from "./MultiTreatyRefNoHelpList.vue?vue&type=template&id=57fa19e0&"
import script from "./MultiTreatyRefNoHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiTreatyRefNoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports